var _path, _path2, _path3, _path4, _path5, _rect, _circle, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFleetEdgeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 214 309",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M127.027 275.405C164.038 275.405 182.549 275.405 194.042 263.902C205.545 252.409 205.545 233.898 205.545 196.887C205.545 159.876 205.545 141.365 194.042 129.872C182.549 118.369 164.038 118.369 127.027 118.369H87.7679C50.7565 118.369 32.2459 118.369 20.7529 129.872C9.25 141.365 9.25 159.876 9.25 196.887C9.25 233.898 9.25 252.409 20.7529 263.902C27.1619 270.321 35.7498 273.157 48.5089 274.404",
    fill: "#0A0A5F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M127.027 275.405C164.038 275.405 182.549 275.405 194.042 263.902C205.545 252.409 205.545 233.898 205.545 196.887C205.545 159.876 205.545 141.365 194.042 129.872C182.549 118.369 164.038 118.369 127.027 118.369H87.7679C50.7565 118.369 32.2459 118.369 20.7529 129.872C9.25 141.365 9.25 159.876 9.25 196.887C9.25 233.898 9.25 252.409 20.7529 263.902C27.1619 270.321 35.7498 273.157 48.5089 274.404",
    stroke: "#0A0A5F",
    strokeWidth: 16.7631,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M107.398 196.885V196.983ZM68.1388 196.885V196.983ZM146.657 196.885V196.983ZM127.027 275.403C114.896 275.403 101.528 280.31 89.3288 286.641C69.7189 296.819 59.914 301.913 55.0852 298.664C50.2563 295.425 51.1691 285.365 53.0045 265.255L53.4167 260.681",
    fill: "#0A0A5F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M107.398 196.885V196.983M68.1388 196.885V196.983M146.657 196.885V196.983M127.027 275.403C114.896 275.403 101.528 280.31 89.3288 286.641C69.7189 296.819 59.914 301.913 55.0852 298.664C50.2563 295.425 51.1691 285.365 53.0045 265.255L53.4167 260.681",
    stroke: "#0A0A5F",
    strokeWidth: 16.7631,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M107.397 196.885V196.983M68.1384 196.885V196.983M146.656 196.885V196.983",
    stroke: "white",
    strokeWidth: 22.9143,
    strokeLinecap: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 99.8848,
    y: 63.9897,
    width: 18.1271,
    height: 48.3389,
    fill: "#0A0A5F"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 108.949,
    cy: 60.9702,
    r: 15.1059,
    fill: "#0A0A5F"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M142.027 62.1995C142.31 54.3761 139.878 46.4225 134.566 39.8528C129.253 33.2831 121.985 29.2412 114.261 27.8785C114.043 27.8441 113.821 27.8951 113.641 28.0209C113.46 28.1467 113.335 28.3374 113.293 28.5532L112.166 34.3295C112.08 34.7912 112.384 35.2343 112.846 35.3205C118.864 36.3459 124.54 39.4869 128.683 44.6103C132.826 49.7337 134.709 55.9406 134.461 62.034C134.448 62.5035 134.818 62.8938 135.287 62.9061L141.172 63.0131C141.626 63.0238 142.009 62.6608 142.027 62.1995ZM161.233 62.5353C161.41 50.4043 157.507 38.1405 149.274 27.959C141.041 17.7776 129.866 11.3946 117.959 9.02149C117.74 8.97929 117.513 9.02551 117.328 9.15008C117.142 9.27464 117.014 9.46745 116.97 9.68645L115.843 15.4628C115.75 15.9162 116.055 16.3594 116.502 16.444C126.724 18.4895 136.327 23.9814 143.391 32.7165C150.454 41.4517 153.815 51.9918 153.669 62.4076C153.665 62.8704 154.028 63.2525 154.491 63.2567L160.375 63.3637C160.838 63.3678 161.229 62.9981 161.233 62.5353Z",
    fill: "#3B96F3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFleetEdgeIcon);
export default __webpack_public_path__ + "static/media/fleet-edge-icon.6f850b7105c2e012cf1a09a10a263940.svg";
export { ForwardRef as ReactComponent };